/* eslint-disable react/prop-types */
import {
  AppBar,
  Button,
  Hidden,
  Menu,
  MenuItem,
  Toolbar,
} from "@material-ui/core"
import ArrowIcon from "@material-ui/icons/ArrowDropDown"
import React, { Fragment, useState } from "react"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import FilterControls from "./FilterControls"
import SearchControl from "./SearchControl"
import SortControls from "./SortControls"
import useStyles from "./styles"

const ActionBar = ({
  left,
  right,
  children,
  onSort,
  sortControls,
  SortControlOptions = {},
  onSearch,
  onFilter,
  searchValue = "",
  filterControls,
  ...rest
}) => {
  const classes = useStyles()

  const [actionsMobileOpen, setActionsMobileOpen] = useState(null)

  const handleCloseActionsMobile = () => {
    setActionsMobileOpen(null)
  }

  const handleActionsMobileMenuItemClick = (cb) => {
    handleCloseActionsMobile()
    cb?.()
  }

  const renderLeftMobile = () => {
    const generateMenuItem = (child) => {
      if (!child) {
        return null
      }
      const { variant, color, children, onClick, ...props } = child.props
      return (
        <MenuItem
          onClick={() => handleActionsMobileMenuItemClick(onClick)}
          {...props}
        >
          {children}
        </MenuItem>
      )
    }
    if (left !== undefined) {
      return React.createElement(
        Menu,
        {
          getContentAnchorEl: null,
          open: actionsMobileOpen !== null,
          anchorEl: actionsMobileOpen,
          onClose: handleCloseActionsMobile,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          classes: {
            paper: classes.actionsMobileMenu,
          },
        },
        React.Children.map(left(), (child) => {
          if (typeof child.props.children === "string") {
            return generateMenuItem(child)
          } else {
            return child.props.children.map((c) => {
              return generateMenuItem(c)
            })
          }
        }),
      )
    } else {
      return null
    }
  }

  const handleOpenActiosnMobile = (e) => {
    setActionsMobileOpen(e.currentTarget)
  }

  return (
    <AppBar position="static" color="default" elevation={1} {...rest}>
      <Toolbar
        className={classes.actionBarToolbar}
        classes={{
          gutters: classes.toolbarGutters,
        }}
      >
        <aside className={classes.leftContent}>
          <Hidden smDown>
            <div className={classes.leftButtons}>{left?.() || ""}</div>
          </Hidden>
          <PermissionsWrapper permissionGroup="admin">
            <Hidden mdUp>
              <Fragment>
                <Button variant="contained" onClick={handleOpenActiosnMobile}>
                  Actions <ArrowIcon />
                </Button>
                {renderLeftMobile()}
              </Fragment>
            </Hidden>
          </PermissionsWrapper>
        </aside>
        {children || ""}
        <aside className={classes.rightContent}>
          {right?.() || ""}
          {onSort && (
            <SortControls
              onSort={onSort}
              controls={sortControls}
              options={SortControlOptions}
            />
          )}
          {onSearch && (
            <SearchControl onSearch={onSearch} value={searchValue} />
          )}
          {filterControls && (
            <FilterControls onFilter={onFilter} controls={filterControls} />
          )}
        </aside>
      </Toolbar>
      <div id="mobile-search" />
      <div id="selected-filters" />
    </AppBar>
  )
}

export default ActionBar
